import { useCallback, useState, useEffect } from 'react';
import useAlert from '../components/Alerts/useAlert';
import { useHttpUtils } from '../utilities/useHttpUtils';

export function useUsers(businessUnitId) {

    const { fetchDataAuthenticated } = useHttpUtils();
    const { setAlert } = useAlert();
    const [users, setUsers] = useState([]);

    const getUsers = useCallback((businessUnitId) => {
        let url = "api/user";
        if (businessUnitId) {
            url += `?businessUnitId=${businessUnitId}`;
        }

        return fetchDataAuthenticated(url)
            .then(async response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error(await response.text());
            })
            .then(data => {
                setUsers(data);
                return data;
            })
            .catch(error => {
                console.error(error.message);
                setAlert("danger", "Failed to get users", error.message);
            });
    }, [fetchDataAuthenticated, setAlert]);

    useEffect(() => {
        if (businessUnitId) {
            getUsers(businessUnitId);
        }
    }, [businessUnitId, getUsers]);

    return { users, getUsers };
}

export function useUserBusinessUnits() {

    const { fetchDataAuthenticated } = useHttpUtils();
    const { setAlert } = useAlert();

    const [userBusinessUnits, setUserBusinessUnits] = useState();

    const getUserBusinessUnits = useCallback(() => {
        return fetchDataAuthenticated(`api/user/businessUnits`)
            .then(async response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error(await response.text());
            })
            .then(data => {
                setUserBusinessUnits(data);
            })
            .catch(error => {
                setAlert("danger", "Failed to get business units for user", error.message);
                setUserBusinessUnits([]);
            });
    }, [fetchDataAuthenticated, setAlert]);

    useEffect(() => {
        getUserBusinessUnits();
    }, [getUserBusinessUnits]);

    const refresh = useCallback(() => {
        getUserBusinessUnits();
    }, [getUserBusinessUnits]);

    return { userBusinessUnits, refresh };
}